import { SurveyEditPageStep } from "@/pages/talent/surveys/edit/survey-edit.ts";
import { ApiSurveyEdit } from "@/types/survey.types.ts";
import { ConfirmationModal, useModals } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export interface SurveyEditPageProps {
  survey: ApiSurveyEdit;
  // onNext: () => void;
}

export const useSurveyEditPage = () => {
  const { openModal } = useModals();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const confirmExit = (id: number) => {
    openModal(ConfirmationModal, {
      question: t("common:unsaved_changes_may_be_lost_title"),
      text: t("common:unsaved_changes_may_be_lost_description"),
      acceptTitle: t("common:leave"),
      secondButtonTitle: t("common:stay"),
      onAccept: async function () {
        navigate(`/surveys/${id}/view/summary`);
      },
    });
  };

  const navigateToStep = (id: number, newStep: SurveyEditPageStep) => {
    navigate(`/surveys/${id}/setup/${newStep}`);
  };

  return {
    confirmExit,
    navigateToStep,
  };
};
